module.exports = __webpack_public_path__ + "media/宣传片.d96f80eb.mp4";